<template>
                            
<div class="card mb-0" v-if="backorderedQty > 0">
    <div class="card-body card-body--padding--1">
        <h5 class="card-title">Backordered Items</h5>
        <table class="checkout__totals">
            <thead class="checkout__totals-header">
            <tr>
                <th>Summary</th>
                <th>Amount</th>
                <th>Line Items</th>
            </tr>
            </thead>
            <tbody class="checkout__totals-products">											                                          
                <tr>
                    <td><strong>Backordered:</strong></td>
                    <td>{{ backorderedTotal }}</td>
                    <td>{{ backorderedQty }}</td>
                </tr>
            </tbody>
        </table>								
        <div class="widget widget-filters--offcanvas--mobile-bg-color" data-collapse>
            <div class="widget-filters__item">
                <div class="filter" data-collapse-item :class="classBOContentClass">
                    <button type="button" class="filter__title filter__title--backordered" @click="showBO = !showBO">
                        BACKORDERED ITEMS (Click to Expand)
                        <span class="filter__arrow"><svg width="12px" height="7px">
                        <path d="M0.286,0.273 L0.286,0.273 C-0.070,0.629 -0.075,1.204 0.276,1.565 L5.516,6.993 L10.757,1.565 C11.108,1.204 11.103,0.629 10.747,0.273 L10.747,0.273 C10.385,-0.089 9.796,-0.086 9.437,0.279 L5.516,4.296 L1.596,0.279 C1.237,-0.086 0.648,-0.089 0.286,0.273 Z" />
                        </svg></span>
                    </button>
                <div class="filter__body" data-collapse-content>
                    <div class="filter__container">
                        <div class="block-space--layout--divider-15"></div>
                        <table class="checkout__totals">
                            <thead class="checkout__totals-header">
                                <tr>
                                    <th class="text-currently-unavailable">Backordered Items</th>
                                    <th class="checkout-summary-qty--head">QTY</th>
                                    <th>AMOUNT</th>
                                </tr>
                            </thead>
                            <tbody class="checkout__totals-products">
                                <tr v-for="item in backorderedItems" :key="item.linenumber">
                                    <td>
                                        <strong>{{ item.desc }}</strong><br>
                                        <small style="margin-right: 10px">Item: {{ item.ID }}</small>
                                        <small>MFR: {{ item.manufacturer }}</small><br>												  
                                    </td>
                                    <td class="checkout-summary-qty">
                                        <div class="checkout-summary-qty"> {{ item.quantity }}</div>
                                    </td>
                                    <td>{{ toUSD(item.linetotal) }}</td>
                                </tr>                            
                            </tbody>
                        </table>
                    </div>
                </div>
                </div>
            </div>
        </div>

    </div>
</div>

</template>

<script>
import { mapGetters } from 'vuex';
import Price from '../../../mixins/price.js';

export default {
    data() {
        return {
            showBO: false,
        }
    },
    mixins: [Price],
    computed: {
        ...mapGetters("cart", [
            "cart",
            "totals"
        ]),
        /**
		 * filter the items on the cart by
		 * location id and as tagged as back order item
		 */
		backorderedItems() {
            const bo_items = this.cart.filter(item => (item.backorder === true));
			
			return bo_items;
        },

		/**
		 * return total of backorder per location
		 */
		backorderedTotal() {
			let bo_total = 0;
            const bo_items = this.cart.filter(item => (item.backorder === true));

			if (bo_items.length > 0){
				bo_items.forEach(i => {
					bo_total += i.linetotal;
				});
			}
			return this.toUSD(bo_total);
        },

		/**
		 * return Units/Qty of backorder per location
		 */
		backorderedQty() {
			let bo_qty = 0;
            const bo_items = this.cart.filter(item => (item.backorder === true));

			if (bo_items.length > 0){
				bo_items.forEach(i => {
					bo_qty += i.quantity;
				});
			}
			return bo_qty;
        },

		classBOContentClass(){
			if (this.showBO)
				return 'filter--closed filter--opened';
			else
				return 'filter--closed';
		}
    },

    created() {
    }
}
</script>